module.exports = __webpack_public_path__ + "static/media/copenhaga-placuta.f6977b65.png";